import React, { createContext, useContext, useReducer, useEffect } from 'react';

const Cartstatecontext = createContext();
const Cartdispatchcontext = createContext();


const reducer = (state, action) => {
    switch (action.type) {
        case "ADD":
            return [...state, {
                shortTitle: action.shortTitle,
                longTitle: action.longTitle,
                img: action.img,
                price: action.price,
                quantity: action.quantity,
            }];
        case "REMOVE":
            const newArr = [...state];
            newArr.splice(action.index, 1);
            return newArr;

        case "UPDATE":
            // Update the existing item in the cart
            return state.map((item) => {
                if (item.shortTitle === action.item.shortTitle) {
                    return {
                        ...item,
                        quantity: action.item.quantity,
                    };
                }
                return item;
            });

        case "SET_TOTAL_PRICE":
            return state.map((item) => {
                return {
                    ...item,
                    totalPrice: action.totalPrice,
                };
            });

        case "SET_ADDRESSID":
            return state.map((item) => {
                return {
                    ...item,
                    addressId: action.addressId,
                    date: new Date().toLocaleDateString("en-US", {
                        day: "numeric",
                        month: "long",
                        year: "numeric",
                    }),
                };
            });


        case "DROP":
            localStorage.removeItem('cartState'); // Remove cart data from local storage
            return [];

        default:
            console.log("Error in Reducer");
            return state;
    }
};

export const CardProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, [], (initialState) => {
        const storedState = localStorage.getItem('cartState');
        return storedState ? JSON.parse(storedState) : initialState;
    });

    useEffect(() => {
        localStorage.setItem('cartState', JSON.stringify(state));
    }, [state]);

    return (
        <Cartdispatchcontext.Provider value={dispatch}>
            <Cartstatecontext.Provider value={state}>
                {children}
            </Cartstatecontext.Provider>
        </Cartdispatchcontext.Provider>
    );
};

export const useCart = () => useContext(Cartstatecontext);
export const useDispatchCart = () => useContext(Cartdispatchcontext);
